import React from 'react'

// components
import {
  CRow,
} from '@coreui/react-pro'
import FormTextInput from '../general-input-form/FormTextInput'
import FormSwitchInput from '../general-input-form/FormSwitchInput'

const AppForm = ({
  values,
  handleChange,
  errors,
  handleSwitch
}) => {
  return (
    <>
      <CRow className="mb-4">
        <FormTextInput 
          id='game_game_name'
          name='game_game_name'
          colSize='6'
          inputLabel='Game Name'
          className='mb-3'
          placeholder='Enter game name...'
          value={values.game_game_name}
          handleTextInput={handleChange}
          feedbackInvalid={errors.game_game_name}
          invalid={errors.game_game_name}
        />
        <FormSwitchInput 
          id='game_is_active'
          name='game_is_active'
          colSize='6'
          inputLabel='Active?'
          className='mb-3'
          handleSwitch={(e) => handleSwitch(e, 'game_is_active')}
          value={values.game_is_active}
          invalid={errors?.game_is_active}
        />
      </CRow>
    </>
  )
}

export default AppForm